import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import loadable from '@loadable/component'
import {
  useProductInfoClickedTracking,
  useAccordionClickedTracking,
} from '../../hooks/tracking'

const RichText = loadable(() => import('../RichText'))

const Accordion = ({
  items,
  className,
  SEO,
  startClosed,
  productInfoTrackingData,
  accordionTrackingData,
}) => {
  const [open, setOpen] = useState(startClosed ? 'null' : 0)
  let timeout

  useEffect(() => {
    const updateOpen = () => {
      if (window.scrollY === 0 && SEO) {
        setOpen('all')
      } else if (SEO) {
        setOpen(open === 'all' ? 0 : open)
      }
    }
    updateOpen()
    window.addEventListener('scroll', updateOpen)

    clearTimeout(timeout)
    
    return () => window.removeEventListener('scroll', updateOpen)
  }, [open, SEO])

  const handleOnClick = ({ e, index, title }) => {
    open === index ? setOpen(null) : setOpen(index)
    // accordions on product page is under Product Info Clicked
    // the rest are Accordion Clicked
    if (productInfoTrackingData && open !== index) {
      useProductInfoClickedTracking({
        ...productInfoTrackingData,
        linkCta: title,
      })
    }
    if (accordionTrackingData && open !== index) {
      useAccordionClickedTracking({
        ...accordionTrackingData,
        title,
      })
    }

    const { currentTarget } = e;
    timeout = setTimeout(() => {
      currentTarget?.scrollIntoViewIfNeeded({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    }, 0)
  }

  return (
    <ul className={className}>
      {items.map(({ title, content, svg, name }, index) => (
        <li key={title + index}>
          <Button
            type='button'
            aria-label={`Read more about "${title}"`}
            className={open === index ? 'active' : null}
            onClick={e => handleOnClick({ e, index, title })}
            active={open === index || open === 'all'}
          >
            {svg && (
              <SVGWrapper
                dangerouslySetInnerHTML={{ __html: svg.svg.content }}
              />
            )}
            {title}
          </Button>
          <Content visible={open === index || open === 'all'}>
            <RichText json={content} />
          </Content>
        </li>
      ))}
    </ul>
  )
}

const Button = styled.button`
  cursor: pointer;
  text-align: left;
`

const Content = styled.div`
  display: ${(props) => (props.visible ? 'block' : 'none')};
`
const SVGWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 !important;
  margin-right: ${(props) => props.theme.space.marginMobile / 2}vw;
  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    margin-right: ${(props) => props.theme.space.marginDesktop / 2}vw;
  }
  svg {
    width: auto;
    height: 4vw;
    @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
      height: 1.1vw;
    }
  }
`

export default Accordion
